module.exports = __webpack_public_path__ + "static/media/xbox.ecf61fc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/xbox.svg
// module id = 1107
// module chunks = 0